import { gql } from "@apollo/client";
import { CampaignHeroFragment, DonateHeroFragment, ShortHeroFragment, TallHeroFragment, VideoHeroFragment, VoucherHeroFragment, TallHero200Fragment, ShortHero200Fragment } from '@components/Hero/Hero.fragment';

export default gql`
  ${ShortHeroFragment}
  ${VideoHeroFragment}
  ${TallHeroFragment}
  ${TallHero200Fragment}
  ${CampaignHeroFragment}
  ${DonateHeroFragment}
  ${VoucherHeroFragment}
  ${ShortHero200Fragment}
  fragment ExperienceListingFragment on ExperienceListingPage {
    metatags {
      metaTitle
      metaRobots
      metaImage {
        md
      }
      metaDescription
      canonical
    }
    hero {
      ...ShortHeroParagraph
      ...TallHeroParagraph
      ...TallHero200Paragraph
      ...VideoHeroParagraph
      ...CampaignHeroParagraph
      ...DonateHeroParagraph
      ...VoucherHeroParagraph
      ...ShortHero200Paragraph
    }
    content {
      id
      alignment
      text {
        processed
        format
        value
      }
    }
    filters {
      experienceType {
        key
        label
      }
      groupSize {
        key
        label
      }
    }
    searchResults {
      total
      pageSize
      page
      totalPages
      resultList {
        id
        title
        path
        teaserImage {
          id
          altText
          url
          sm
          md
          lg
          xl
        }
        teaserDescription
        teaserEyebrow
        experienceType {
          id
          name
          title
          description
        }
      }
    }
  }
`;
